import React from 'react';
import { motion } from 'framer-motion';
import { config } from '../config/config';

const Process = () => {
  return (
    <section className="process" id="process">
      <motion.p
        className="sec-label"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        How It Works
      </motion.p>
      <motion.h2
        className="sec-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        4 SIMPLE <span style={{ color: 'var(--gold)' }}>STEPS</span>
      </motion.h2>
      <div className="proc-grid">
        {config.processSteps.map((step, idx) => (
          <motion.div
            key={idx}
            className="proc-step"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            whileHover={{ y: -10 }}
          >
            <div className="proc-num">{step.number}</div>
            <div className="proc-circle">{step.number}</div>
            <div className="proc-title">{step.title}</div>
            <p className="proc-desc">{step.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Process;
